var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#graph_container[data-v-e830862e]{position:relative;top:0;bottom:0;left:0;right:0;width:100mm;height:70mm}#graph_main[data-v-e830862e]{background-color:#d3d3d3;overflow:auto}.backGroundImage[data-v-e830862e]{-webkit-box-shadow:#666 0 0 10px;box-shadow:0 0 10px #666;background:url(" + escape(require("../../assets/mxgraph-source/images/images/grid.gif")) + ")}.backGroundNone[data-v-e830862e]{background:none}", ""]);

// exports
